<section class="elegibilidade" aria-labelledby="antecipacao-titulo" data-testid="beneficios-antecipacao">
  <header class="elegibilidade__topo">
    <span class="elegibilidade__icone" aria-hidden="true">
      <vivest-icon name="fast-forward" source="feather"></vivest-icon>
    </span>
    <div class="elegibilidade__titulo-grupo">
      <h2 id="antecipacao-titulo" class="elegibilidade__titulo">Antecipação</h2>
      <p class="elegibilidade__descricao">
        Configure a antecipação de saldo e o adiantamento de benefício do plano. Valem para todos os benefícios.
      </p>
    </div>
  </header>

  @if (carregou()) {
    <div class="elegibilidade__blocos">
      <section class="elegibilidade-parametros" aria-labelledby="antecipacao-parametros-titulo">
        <div class="elegibilidade-parametros__cabecalho">
          <h3 id="antecipacao-parametros-titulo" class="elegibilidade__subtitulo">
            Parâmetros de Antecipação{{ nomePlano() ? ': ' : '' }}
            @if (nomePlano()) {
              <span class="elegibilidade-parametros__beneficio" data-testid="antecipacao-plano">{{ nomePlano() }}</span>
            }
          </h3>
        </div>

        <form
          class="elegibilidade-regras"
          novalidate
          [formGroup]="form"
          (submit)="$event.preventDefault(); salvar()"
          data-testid="antecipacao-form"
        >
          <fieldset
            class="elegibilidade-bloco"
            aria-labelledby="antecipacao-bloco-saldo"
            formGroupName="saldo"
            data-testid="antecipacao-bloco-saldo"
          >
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="antecipacao-bloco-saldo" class="elegibilidade-bloco__titulo">Antecipação de saldo</h4>
              <p class="elegibilidade-bloco__regra">O participante pode antecipar parte do saldo à vista.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <div class="elegibilidade-interruptor">
                <vivest-switch
                  formControlName="permitir"
                  aria-labelledby="antecipacao-permitir-rotulo"
                  data-testid="antecipacao-permitir"
                ></vivest-switch>
                <span id="antecipacao-permitir-rotulo" class="elegibilidade-interruptor__texto">
                  Permitir antecipação de saldo
                  <span class="elegibilidade-interruptor__estado">
                    {{ form.controls.saldo.controls.permitir.value ? 'Sim' : 'Não' }}
                  </span>
                </span>
              </div>

              <!-- Desligada, os percentuais ficam guardados e voltam ao religar. -->
              @if (form.controls.saldo.controls.permitir.value) {
                <div class="elegibilidade-detalhe" data-testid="antecipacao-detalhe-saldo">
                  <p class="elegibilidade-frase">
                    <span>De</span>
                    <input
                      type="number"
                      inputmode="decimal"
                      min="0.01"
                      max="25"
                      step="0.01"
                      placeholder="0"
                      aria-label="Percentual mínimo do saldo"
                      class="form-control campanha-form-control elegibilidade-frase__numero"
                      formControlName="percentualMinimo"
                      [class.is-invalid]="!!erroPercentuais()"
                      data-testid="antecipacao-minimo"
                    />
                    <span>% a</span>
                    <input
                      type="number"
                      inputmode="decimal"
                      min="0.01"
                      max="25"
                      step="0.01"
                      placeholder="0"
                      aria-label="Percentual máximo do saldo"
                      class="form-control campanha-form-control elegibilidade-frase__numero"
                      formControlName="percentualMaximo"
                      [class.is-invalid]="!!erroPercentuais()"
                      data-testid="antecipacao-maximo"
                    />
                    <span>% do saldo</span>
                  </p>
                  @if (erroPercentuais(); as mensagem) {
                    <p class="elegibilidade__erro" role="alert" data-testid="antecipacao-erro-saldo">{{ mensagem }}</p>
                  }
                </div>
              }
            </div>
          </fieldset>

          <fieldset
            class="elegibilidade-bloco"
            aria-labelledby="antecipacao-bloco-adiantamento"
            formGroupName="adiantamentoBeneficio"
            data-testid="antecipacao-bloco-adiantamento"
          >
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="antecipacao-bloco-adiantamento" class="elegibilidade-bloco__titulo">Adiantamento de benefício</h4>
              <p class="elegibilidade-bloco__regra">Permite que o participante solicite adiantamento do benefício.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <div class="elegibilidade-interruptor">
                <vivest-switch
                  formControlName="elegivel"
                  aria-labelledby="antecipacao-adiantamento-rotulo"
                  data-testid="antecipacao-adiantamento"
                ></vivest-switch>
                <span id="antecipacao-adiantamento-rotulo" class="elegibilidade-interruptor__texto">
                  Elegível para adiantamento de benefício
                  <span class="elegibilidade-interruptor__estado">
                    {{ form.controls.adiantamentoBeneficio.controls.elegivel.value ? 'Sim' : 'Não' }}
                  </span>
                </span>
              </div>

              <!-- Desligado, o percentual fica guardado e volta ao religar. -->
              @if (form.controls.adiantamentoBeneficio.controls.elegivel.value) {
                <div class="elegibilidade-detalhe" data-testid="antecipacao-detalhe-adiantamento">
                  <p class="elegibilidade-frase">
                    <span>Até</span>
                    <input
                      type="number"
                      inputmode="decimal"
                      min="0.01"
                      max="100"
                      step="0.01"
                      placeholder="0"
                      aria-label="Percentual de adiantamento do benefício"
                      class="form-control campanha-form-control elegibilidade-frase__numero"
                      formControlName="percentual"
                      [class.is-invalid]="!!erroPercentualAdiantamento()"
                      data-testid="antecipacao-adiantamento-percentual"
                    />
                    <span>% do benefício</span>
                  </p>
                  @if (erroPercentualAdiantamento(); as mensagem) {
                    <p class="elegibilidade__erro" role="alert" data-testid="antecipacao-erro-adiantamento">{{ mensagem }}</p>
                  }
                </div>
              }
            </div>
          </fieldset>
        </form>
      </section>

      <aside class="elegibilidade-resumo" aria-labelledby="antecipacao-resumo-titulo" data-testid="antecipacao-resumo">
        <h3 id="antecipacao-resumo-titulo" class="elegibilidade-resumo__titulo">Resumo{{ nomePlano() ? ' (' + nomePlano() + ')' : '' }}</h3>
        <ul class="elegibilidade-resumo__itens" data-testid="antecipacao-resumo-itens">
          @for (item of resumo(); track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      </aside>
    </div>

    <footer class="elegibilidade__rodape">
      @if (temAlteracoes()) {
        <span class="elegibilidade__pendente" data-testid="antecipacao-alteracoes-pendentes">Há alterações não salvas</span>
      }
      <vivest-button variant="outline" size="md" [disabled]="!temAlteracoes()" data-testid="antecipacao-cancelar" (click)="descartar()">
        Cancelar
      </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!temAlteracoes()" data-testid="antecipacao-salvar" (click)="salvar()">
        <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  }
</section>

<vivest-modal
  heading="Salvar antecipação"
  description="A antecipação passa a valer para todos os benefícios do plano nas próximas solicitações. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="confirmandoSalvar.set(false)"
  data-testid="antecipacao-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="antecipacao-confirmar-voltar" (click)="confirmandoSalvar.set(false)">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="antecipacao-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
